// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__tableBox--oBwzn {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__header--YTaxX {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__body--USIVD {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__cells--KBa9y {
  display: grid;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__cells--KBa9y .ant-input-number {
  background: none;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderTop--t9csC {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderLeft--xHWJH {
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderRB--fS5XK {
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__emptyBox--Im09a {
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__th--pMG2I {
  padding: 4px 8px;
  color: rgba(0, 0, 0, 0.55);
  background: #fafafa;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__baseSizeCell--NL2VU {
  background-color: rgba(133, 165, 255, 0.1);
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__leftAlign--Kr8I5 {
  text-align: left;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__rightAlign--DU099 {
  text-align: right;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__centerAlign--GXEIR {
  text-align: center;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__actualRed--m_nCF {
  color: #c20034;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__actualRed--m_nCF input {
  color: #c20034 !important;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__static--jOT9S {
  color: rgba(0, 0, 0, 0.55);
  font-weight: 400;
  line-height: 160%;
  display: flex;
  margin: 5px 12px;
  align-items: center;
  gap: 4px;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__static--jOT9S span {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__centred--oyh5t {
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsSample2/Sample2View/Sample2Table/Sample2Table.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEA;EACE,aAAA;EACA,gBAAA;AAAF;AAGA;EACE,OAAA;EACA,cAAA;AADF;AAIA;EACE,aAAA;AAFF;AACA;EAGI,gBAAA;AADJ;AAOA;EACE,0CAAA;AALF;AAOA;EACE,2CAAA;AALF;AAOA;EACE,4CAAA;EACA,6CAAA;AALF;AAQA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANF;AASA;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPF;AAUA;EACE,0CAAA;AARF;AAWA;EACE,gBAAA;AATF;AAWA;EACE,iBAAA;AATF;AAWA;EACE,kBAAA;AATF;AAYA;EACE,cAAA;AAVF;AASA;EAGI,yBAAA;AATJ;AAaA;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;EAEA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AAZF;AAIA;EAWI,uBAAA;EACA,mBAAA;EACA,gBAAA;AAZJ;AAeA;EACE,uBAAA;AAbF","sourcesContent":[".tableBox {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  display: grid;\n  overflow: hidden;\n}\n\n.body {\n  flex: 1;\n  overflow: auto;\n}\n\n.cells {\n  display: grid;\n  :global(.ant-input-number) {\n    background: none;\n  }\n}\n\n@border: thin solid rgba(0, 0, 0, 0.12);\n\n.borderTop {\n  border-top: @border;\n}\n.borderLeft {\n  border-left: @border;\n}\n.borderRB {\n  border-right: @border;\n  border-bottom: @border;\n}\n\n.emptyBox {\n  padding: 16px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.th {\n  padding: 4px 8px;\n  color: rgba(0, 0, 0, 0.55);\n  background: #fafafa;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.baseSizeCell {\n  background-color: rgba(133, 165, 255, 0.1);\n}\n\n.leftAlign {\n  text-align: left;\n}\n.rightAlign {\n  text-align: right;\n}\n.centerAlign {\n  text-align: center;\n}\n\n.actualRed {\n  color: #c20034;\n  input {\n    color: #c20034 !important;\n  }\n}\n\n.static {\n  color: rgba(0, 0, 0, 0.55);\n  font-weight: 400;\n  line-height: 160%;\n\n  display: flex;\n  margin: 5px 12px;\n  align-items: center;\n  gap: 4px;\n\n  span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n}\n.centred {\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBox": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__tableBox--oBwzn`,
	"header": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__header--YTaxX`,
	"body": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__body--USIVD`,
	"cells": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__cells--KBa9y`,
	"borderTop": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderTop--t9csC`,
	"borderLeft": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderLeft--xHWJH`,
	"borderRB": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__borderRB--fS5XK`,
	"emptyBox": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__emptyBox--Im09a`,
	"th": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__th--pMG2I`,
	"baseSizeCell": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__baseSizeCell--NL2VU`,
	"leftAlign": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__leftAlign--Kr8I5`,
	"rightAlign": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__rightAlign--DU099`,
	"centerAlign": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__centerAlign--GXEIR`,
	"actualRed": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__actualRed--m_nCF`,
	"static": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__static--jOT9S`,
	"centred": `src-businessServices-services-bsSample2-Sample2View-Sample2Table-Sample2Table-module__centred--oyh5t`
};
export default ___CSS_LOADER_EXPORT___;
